export function getUserPermissions(): string[] {
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  return permissions;
}

export function IsPermissionExist(requiredPermission: string): boolean {
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  return permissions.find((p) => p.toLowerCase() == requiredPermission?.toLowerCase());
}
